module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/noti_mujer_5-e779988b314b019f9adc0e0c6cea50dc.jpg";